import { apiSlice } from '@/core/api/apiSlice';
import { ApiResponse, PaginatedResponse } from '@/types/common.types';
import {
  CreditBalanceSummary,
  LedgerEntry,
  CheckoutSessionRequest,
  CheckoutSessionResponse,
  PortalSessionResponse,
} from '@/types/billing.types';

export const billingApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createCheckoutSession: builder.mutation<
      ApiResponse<CheckoutSessionResponse>,
      CheckoutSessionRequest
    >({
      query: (body) => ({
        url: '/billing/checkout',
        method: 'POST',
        body,
      }),
    }),

    syncCheckoutSession: builder.mutation<ApiResponse<null>, { session_id: string }>({
      query: ({ session_id }) => ({
        url: `/billing/checkout/sync?session_id=${session_id}`,
        method: 'POST',
      }),
      invalidatesTags: ['BillingBalance', 'BillingHistory'],
    }),

    createPortalSession: builder.mutation<ApiResponse<PortalSessionResponse>, void>({
      query: () => ({
        url: '/billing/portal',
        method: 'GET',
      }),
    }),

    getBillingBalance: builder.query<ApiResponse<CreditBalanceSummary>, void>({
      query: () => '/billing/balance',
      providesTags: ['BillingBalance'],
    }),

    getBillingHistory: builder.query<
      ApiResponse<{ data: LedgerEntry[]; pagination: any }>,
      { page?: number; limit?: number }
    >({
      query: ({ page = 1, limit = 20 } = {}) =>
        `/billing/history?page=${page}&limit=${limit}`,
      providesTags: ['BillingHistory'],
    }),
  }),
});

export const {
  useCreateCheckoutSessionMutation,
  useSyncCheckoutSessionMutation,
  useCreatePortalSessionMutation,
  useGetBillingBalanceQuery,
  useGetBillingHistoryQuery,
} = billingApi;
